import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ConnectionsRoute } from '../../routing'

export  class ConnectionsPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ConnectionsRoute />
            </Fragment>
        )
    }
}
